<template>
    <div>
        <span>{{ $_.get(activity, 'actorUser.name') }} kullanıcısı görev başlığını "{{ $_.get(activity, 'payload.oldTitle') }}" den "{{ $_.get(activity, 'payload.newTitle') }}" olarak güncelledi.</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskUpdateTitle",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>
<style scoped lang="scss"></style>
